import { useGrowWithFaireDetails } from "@faire/deprecated-retailer-visitor-shared/features/GrowWithFaire/useGrowWithFaireDetails";
import { useShouldAdvertiseHolidaySpendChallenge } from "@faire/deprecated-retailer-visitor-shared/features/GrowWithFaire/useShouldAdvertiseHolidaySpendChallenge";
import { useMilestone } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useMilestone";
import { GROW_WITH_FAIRE_CURRENT_TIP_SEEN } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/GROW_WITH_FAIRE_CURRENT_TIP_SEEN";
import { route as homeRoute } from "@faire/web-api--source/routes/www/root";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { useLocation } from "react-router-dom";

export const useGrowWithFaireNudge = () => {
  const { pathname } = useLocation();
  const { isOfferActive } = useShouldAdvertiseHolidaySpendChallenge();
  const { isEnrolled } = useGrowWithFaireDetails();
  const isHomePage = pathMatchesRoute(pathname, homeRoute);

  const { hasOccurred: hasSeenNudge, setHasOccurred: setHasSeenNudge } =
    useMilestone(GROW_WITH_FAIRE_CURRENT_TIP_SEEN);

  const isNudgeShown =
    isOfferActive && isEnrolled && !hasSeenNudge && !isHomePage;

  return {
    isNudgeShown,
    dismissNudge: setHasSeenNudge,
  };
};
